module.exports = __webpack_public_path__ + "img/ic-master-card-no-color.3ef921fb.svg";